import React, {
  useRef, useCallback,
} from 'react';
import { Grid } from '@material-ui/core';
import isEqual from 'react-fast-compare';

import { PaginationController } from './components';
import Table, { TableProps } from '../Table';
import Memo from '../Memo';
import Box from '../Box';
import Text from '../Text';
import { getCurrentPaginationText } from '../../utils/tableUtils';


type Props = {
  currentPage: number;
  onGoToPage: (pageNumber: number) => void;
  itemsPerPage: number;
  totalCount: number;
} & TableProps;

const PaginatedTable: React.FC<Props> = (props: Props) => {
  const {
    currentPage,
    onGoToPage,
    itemsPerPage,
    totalCount,
    ...tableProps
  } = props;

  const divRef = useRef<HTMLDivElement>();

  const handleTableUpdate = useCallback(() => {
    divRef.current?.scrollTo(0, 0);
  }, [divRef]);

  return (
    <Box border="1px solid #F0F0F0">
      <Table onTableUpdate={handleTableUpdate} ref={divRef} {...tableProps} />
      <Box height="60px" display="flex" boxShadow="1px">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Text margin="0px 13px">
            {getCurrentPaginationText(currentPage, itemsPerPage, totalCount)}
          </Text>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          <Box display="inline-flex" margin="14px 17px">
            <PaginationController
              onTableUpdate={handleTableUpdate}
              onGoToPage={onGoToPage}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              totalCount={totalCount}
            />
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

export default Memo(PaginatedTable, isEqual);
